import React from 'react'
import { Grid } from '@mui/material'
import { ViewItem } from '../../ViewItem/ViewItem'

interface PositionAlertsDetailsHeaderProps {
  warehouseName: string
  zoneName: string
  positionCode: string
  typePositionName: string
}

export const PositionAlertDetailsHeader: React.FC<PositionAlertsDetailsHeaderProps> =
  ({ positionCode, typePositionName, warehouseName, zoneName }) => {
    return (
      <Grid container item xs={12}>
        <Grid item xs={12} sm={3} justify='center'>
          <ViewItem dense title='Almacén' text={warehouseName} />
        </Grid>
        <Grid item xs={12} sm={3} justify='center'>
          <ViewItem dense title='Zona' text={zoneName} />
        </Grid>
        <Grid item xs={12} sm={3} justify='center'>
          <ViewItem dense title='Posición' text={positionCode} />
        </Grid>
        <Grid item xs={12} sm={3} justify='center'>
          <ViewItem dense title='Tipo Posición' text={typePositionName} />
        </Grid>
        {/* No queda muy claro en la historia si se debe hacer o no */}
        {/* <Grid item xs={6} sm={3}>
          <ViewItem dense title='Unidades en posición' text={'1567'} />
        </Grid> */}
      </Grid>
    )
  }
